import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=3f94ce92&scoped=true"
import script from "./detail.vue?vue&type=script&setup=true&lang=js"
export * from "./detail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=3f94ce92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f94ce92",
  null
  
)

export default component.exports